import {
  CREATE_USER,
  EMAIL_VERIFY,
  GET_USER_INFO,
  LOG_IN,
  LOG_OUT,
  NEW_PASSWORD,
  RESET_PASSWORD_REQUEST,
  SOCIAL_LOGIN,
  SUBSCRIBE,
  SOCIAL_LOGIN_EMAIL_VERIFICATION,
  PASSWORD_RECOVERY_EMAIL_VERIFY,
} from './types';

/** Login, Register User */

export const logIn = (user) => ({
  type: LOG_IN,
  payload: user,
});

export const userReg = (user) => ({
  type: CREATE_USER,
  payload: user,
});

/** End */

/** Log Out */

export const logOut = () => ({
  type: LOG_OUT,
});

/** End */

/** Change Password */

export const resetPassword = (email) => ({
  type: RESET_PASSWORD_REQUEST,
  payload: email,
});

/** End */

/** UserInfo */

export const userInfo = () => ({
  type: GET_USER_INFO,
});

/** End */

/** Subscribe */
export const subscribe = (email) => ({
  type: SUBSCRIBE,
  payload: email,
});

/** End */

/** new password */
export const newPassword = (body) => ({
  type: NEW_PASSWORD,
  payload: body,
});

/** End */

/** socialLogin */
export const socialLogin = (body) => ({
  type: SOCIAL_LOGIN,
  payload: body,
});

/** End */

/** email-verify */
export const emailVerify = (code) => ({
  type: EMAIL_VERIFY,
  payload: code,
});

/** End */

/** social--login-email-verification */
export const socialLoginEmailVerification = (body) => ({
  type: SOCIAL_LOGIN_EMAIL_VERIFICATION,
  payload: body,
});

/** End */

/** email verify in forgot password */
export const sendCodeRecoveryPassword = (body) => ({
  type: PASSWORD_RECOVERY_EMAIL_VERIFY,
  payload: body,
});

/** End */
